import { render, staticRenderFns } from "./TianDiTuPage.vue?vue&type=template&id=20120da2"
import script from "./TianDiTuPage.vue?vue&type=script&lang=js"
export * from "./TianDiTuPage.vue?vue&type=script&lang=js"
import style0 from "./TianDiTuPage.vue?vue&type=style&index=0&id=20120da2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports